export class FineModel {

    public acceso: number;
    public rolAcceso: number;
    public rolPermiso: number;
    public cliente: string;
    public contrato: string;
    public fechaInicioContrato: any;
    public fechaFinContrato: any;
    public expedienteGesthispania: string;
    public nombreOrganismo: string;
    public codigoSancion: string;
    public lugar: string;
    public matricula: string;
    public tipoInfraccion: string;
    public estado: string;
    public fechaFinEnlace: any;
    public importeAPagar: number;
    public importePagado: number;
    public isProcessingPay: boolean;
    public importeBrutoConDescuento: number;
    public comisionConDescuento: number;
    public idEnlace: string;
    public pagoActivo: boolean;

    constructor(obj: DataObj) {
        this.cliente = obj && obj.cliente || null;
        this.contrato = obj && obj.contrato || null;
        this.fechaInicioContrato = obj && obj.fechaInicioContrato || null;
        this.fechaFinContrato = obj && obj.fechaFinContrato || null;
        this.expedienteGesthispania = obj && obj.expedienteGesthispania || null;
        this.nombreOrganismo = obj && obj.nombreOrganismo || null;
        this.codigoSancion = obj && obj.codigoSancion || null;
        this.lugar = obj && obj.lugar || null;
        this.matricula = obj && obj.matricula || null;
        this.tipoInfraccion = obj && obj.tipoInfraccion || null;
        this.estado = obj && obj.estado || null;
        this.fechaFinEnlace = obj && obj.fechaFinEnlace || null;
        this.importeAPagar = obj && obj.importeAPagar || null;
        this.importeBrutoConDescuento = obj && obj.importeBrutoConDescuento || null;
        this.comisionConDescuento = obj && obj.comisionConDescuento || null;
        this.importePagado = obj && obj.importePagado || null;
        this.isProcessingPay = obj && obj.isProcessingPay || null;
        this.acceso = obj && obj.acceso || null;
        this.rolAcceso = obj && obj.rolAcceso || null;
        this.rolPermiso = obj && obj.rolPermiso || null;
        this.idEnlace = obj && obj.idEnlace || null;
        this.pagoActivo = obj && obj.pagoActivo || null;
    }

}

interface DataObj {
    acceso: number;
    rolAcceso: number;
    rolPermiso: number;
    cliente: string;
    contrato: string;
    fechaInicioContrato: any;
    fechaFinContrato: any;
    expedienteGesthispania: string;
    nombreOrganismo: string;
    codigoSancion: string;
    lugar: string;
    matricula: string;
    tipoInfraccion: string;
    estado: string;
    fechaFinEnlace: any;
    importeAPagar?: number;
    importeBrutoConDescuento?: number;
    importePagado?: number;
    isProcessingPay?: boolean;
    comisionConDescuento?: number;
    idEnlace?: string;
    pagoActivo?: boolean;
}
